import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
// import { all_routes } from "../../../../Router/all_routes";
import { RotateCcw } from "feather-icons-react/build/IconComponents";

import Table from "../../../../core/pagination/datatable";
import { Select, Spin } from "antd";
import { ROLL_CALL_API_BASE_URL } from "../RollCallConfig/RollCallConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import 'jspdf-autotable';

const LeaveAccurals = () => {

  // const [selectedEmp, setSelectedEmp] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  // const [employees, setEmployees] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);


  const years = [2023, 2024, 2025];


  // useEffect(() => {
  //   if (tokenData && superIdData) {
  //     const fetchEmployeeData = async () => {
  //       try {
  //         const response = await fetch(
  //           `${ROLL_CALL_API_BASE_URL}portal/emp/getEmployee?superid=${superIdData}`,
  //           {
  //             method: "GET",
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${tokenData}`,
  //             },
  //           }
  //         );

  //         if (!response.ok) throw new Error("Failed to fetch employees");

  //         const data = await response.json();
  //         if (data.status) setEmployees(data.ResultData || []);
  //         else console.error("Error fetching employees:", data.ErrorMsg);
  //       } catch (error) {
  //         console.error("Error fetching employees:", error);
  //       }
  //     };

  //     fetchEmployeeData();
  //   }
  // }, [tokenData, superIdData]);

  // const empOptions = employees.map((emp) => ({
  //   value: emp.regid,
  //   label: emp.UserName,
  // }));



  const handleLeavesView = async () => {
    if (superIdData && tokenData) {
      setLoading(true);
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/leave/getLeaveAccrualsForAdmin?SuperId=${superIdData}&Year=${selectedYear}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
          }
        );
        const data = await response.json();

        if (data?.status) {
          setData(data.ResultData || []);
        } else {
          console.error(
            "Failed to fetch employees:",
            data?.ErrorMsg || response.statusText
          );
        }
      } catch (error) {
        console.error("Error fetching employees:", error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const filteredData = data.filter((item) => {
    return (
      (item.UserName && item.UserName.toLowerCase()) ||
      (item.Comments && item.Comments.toLowerCase()) ||
      (item.LvCode && item.LvCode.toString())
    );
  });

  const columns = [
    {
      title: "Id",
      dataIndex: "Id",
      sorter: (a, b) => a.Id.length - b.Id.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },

    {
      title: "Employee",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName.length - b.UserName.length,
      render: (text) =>
        <span>
          {text.length > 15 ? `${text.substring(0, 15)}...` : text}
        </span>
    },
    {
      title: "Designation",
      dataIndex: "Designation",
      sorter: (a, b) => a.Designation.length - b.Designation.length,
      render: (text) =>
        <span>
          {text.length > 15 ? `${text.substring(0, 15)}...` : text}
        </span>
    },
    {
      title: "Carry Forward",
      dataIndex: "CarryForwardLeaves",
      sorter: (a, b) => a.CarryForwardLeaves.length - b.CarryForwardLeaves.length,
    },
    {
      title: "Accrued",
      dataIndex: "Accrued",
      sorter: (a, b) => a.Accrued.length - b.Accrued.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Taken",
      dataIndex: "Taken",
      sorter: (a, b) => a.Taken.length - b.Taken.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Balance",
      dataIndex: "Balance",
      sorter: (a, b) => a.Balance.length - b.Balance.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
  ];

  const generatePDF = () => {
    if (filteredData && filteredData.length === 0) {
      return;
    }
    const doc = new jsPDF();
    
    doc.text("Leave Data Report", 14, 10);

    const tableColumn = ["S.No", "LeaveType", "Carry", "Balance", "Taken", "Accrued"];
    const tableRows = filteredData.map((item, index) => [
      index + 1,
      item.LeaveTypeName || "N/A",
      item.CarryForwardLeaves || "N/A",
      item.Balance || "N/A",
      item.Taken || "N/A",
      item.Accrued || "N/A",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
    doc.save("Leave_Data.pdf");
  };

  const handleDownloadExcel = () => {
    if (filteredData && filteredData.length === 0) {
      return;
    }
    const wb = XLSX.utils.book_new();
    const wsData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "LeaveType": item.LeaveType || "N/A",
      "Carry": item.CarryForwardLeaves || "N/A",
      "Balance": item.Balance || "N/A",
      "Taken": item.Taken || "N/A",
      "Accrued": item.Accrued || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Leave Data");
    XLSX.writeFile(wb, "Leave_Data.xlsx");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const handleReload = () => {
    window.location.reload();
  };


  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/rollcall/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Leave Accurals
                  </h4>
                </ol>
              </nav>
              <h6>Find your Leave Accurals here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link onClick={generatePDF}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={handleDownloadExcel}>
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>

            <li onClick={handleReload}>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>

          </ul>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set"></div>
            <div className="d-flex justify-content-end align-items-end row">
              {/* <div className="col-5">
                <label className="form-label">Employee</label>
                <Select
                  placeholder="Choose Employee"
                  value={selectedEmp}
                  onChange={setSelectedEmp}
                  options={empOptions}
                  style={{ width: 200 }}
                />
              </div> */}
              <div className="col-7">

                <Select
                  placeholder="Year"
                  style={{ width: 100, height: 37 }}
                  onChange={(value) => {
                    setSelectedYear(value);
                  
                  }}
                >
                  {years.map((year) => (
                    <Select.Option key={year} value={year}>
                      {year}
                    </Select.Option>
                  ))}
                </Select>
              </div>
              <div className="col-2 " style={{marginRight:" 23px"}}>
                <button className="btn btn-primary" onClick={handleLeavesView}>
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </button>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {loading ? (
                <div className="text-center my-4">
                  <Spin size="large" />
                  <p>Loading data...</p>
                </div>
              ) : (
                <Table columns={columns} dataSource={Array.isArray(filteredData) ? filteredData : []} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveAccurals;
